import type { CatalogListResponse } from '../types/resourceCatalog';

export async function fetchCatalogResources(params: URLSearchParams): Promise<CatalogListResponse> {
  const response = await fetch(`/api/tools/resources?${params.toString()}`);
  const body = (await response.json().catch(() => null)) as
    | CatalogListResponse
    | { success?: false }
    | null;
  if (!response.ok || !body || body.success !== true) {
    throw new Error('Failed to load resources');
  }
  return body;
}
